import { actions, dropdownIconContainer, dropdownListContainer, inputBaseActionArea, inputBaseClearButton, inputBaseInputButtonContainer, inputBaseInputHolder, inputBaseInputWrapper, inputBaseLabelStyles, inputBaseMainContainerStyles, inputBaseSeparatorStyles, inputContainerBaseStyles, inputFullContainerStyles, inputIconBase, loader, loaderDot, loaderDot1, loaderDot2, loadingAnimation, staticSelect, staticSelectPlaceholder, staticSelectWrapper, tagContainerStyles, } from '../styles/legacy';
import { actions as actionsCitrus2022, dropdownIconContainer as dropdownIconContainerCitrus2022, dropdownListContainer as dropdownListContainerCitrus2022, inputBaseActionArea as inputBaseActionAreaCitrus2022, inputBaseClearButton as inputBaseClearButtonCitrus2022, inputBaseInputButtonContainer as inputBaseInputButtonContainerCitrus2022, inputBaseInputHolder as inputBaseInputHolderCitrus2022, inputBaseInputWrapper as inputBaseInputWrapperCitrus2022, fakePlaceholderStyles as inputBaseLabelStylesCitrus2022, inputBaseMainContainerStyles as inputBaseMainContainerStylesCitrus2022, inputBaseSeparatorStyles as inputBaseSeparatorStylesCitrus2022, inputContainerBaseStyles as inputContainerBaseStylesCitrus2022, inputFullContainerStyles as inputFullContainerStylesCitrus2022, inputIconBase as inputIconBaseCitrus2022, loader as loaderCitrus2022, loaderDot as loaderDotCitrus2022, loadingAnimation as loadingAnimationCitrus2022, staticSelect as staticSelectCitrus2022, staticSelectPlaceholder as staticSelectPlaceholderCitrus2022, staticSelectWrapper as staticSelectWrapperCitrus2022, tagContainerStyles as tagContainerStylesCitrus2022, } from '../styles/citron';
import React from 'react';
import { css } from 'emotion';
import { citrusStyled } from '@citrus/runtime';
export var SelectStaticWrapper = citrusStyled.div('staticSelectWrapper', {
    legacy: staticSelectWrapper,
    citrus2022: staticSelectWrapperCitrus2022,
});
export var SelectStatic = citrusStyled.select('staticSelect', {
    legacy: staticSelect,
    citrus2022: staticSelectCitrus2022,
});
export var Actions = citrusStyled.div('actions', { legacy: actions, citrus2022: actionsCitrus2022 });
export var DropdownListContainer = citrusStyled.div('dropdownListContainer', {
    legacy: dropdownListContainer,
    citrus2022: dropdownListContainerCitrus2022,
});
export var InputBaseMainContainerStyles = citrusStyled.div('inputBaseMainContainerStyles', {
    legacy: inputBaseMainContainerStyles,
    citrus2022: inputBaseMainContainerStylesCitrus2022,
});
export var InputBaseActionArea = citrusStyled.div('inputBaseActionArea', {
    legacy: inputBaseActionArea,
    citrus2022: inputBaseActionAreaCitrus2022,
});
export var InputFullContainer = citrusStyled.div('inputFullContainerStyles', {
    legacy: inputFullContainerStyles,
    citrus2022: inputFullContainerStylesCitrus2022,
});
export var InputContainerBase = citrusStyled.div('inputContainerBaseStyles', {
    legacy: inputContainerBaseStyles,
    citrus2022: inputContainerBaseStylesCitrus2022,
});
export var InputBaseInputHolder = citrusStyled.div('inputBaseInputHolder', {
    legacy: inputBaseInputHolder,
    citrus2022: inputBaseInputHolderCitrus2022,
});
export var InputBaseInputButtonContainer = citrusStyled.div('inputBaseInputButtonContainer', {
    legacy: inputBaseInputButtonContainer,
    citrus2022: inputBaseInputButtonContainerCitrus2022,
});
export var InputBaseLabel = citrusStyled.div('inputBaseLabelStyles', {
    legacy: inputBaseLabelStyles,
    citrus2022: inputBaseLabelStylesCitrus2022,
});
export var InputBaseClearButton = citrusStyled.div('inputBaseClearButton', {
    legacy: inputBaseClearButton,
    citrus2022: inputBaseClearButtonCitrus2022,
});
export var InputBaseInputWrapper = citrusStyled.div('inputBaseInputWrapper', {
    legacy: inputBaseInputWrapper,
    citrus2022: inputBaseInputWrapperCitrus2022,
});
export var InputIconBase = citrusStyled.div('inputIconBase', {
    legacy: inputIconBase,
    citrus2022: inputIconBaseCitrus2022,
});
export var InputBaseSeparator = citrusStyled.span('inputBaseSeparatorStyles', {
    legacy: inputBaseSeparatorStyles,
    citrus2022: inputBaseSeparatorStylesCitrus2022,
});
export var DropdownIconContainer = citrusStyled.span('dropdownIconContainer', {
    legacy: dropdownIconContainer,
    citrus2022: dropdownIconContainerCitrus2022,
});
export var TagContainerStyles = citrusStyled.div('tagContainerStyles', {
    legacy: tagContainerStyles,
    citrus2022: tagContainerStylesCitrus2022,
});
export var ListRow = citrusStyled.div('N/A', null);
export var SelectAll = citrusStyled.div('N/A', null);
var Loader = citrusStyled.div('loader', { legacy: loader, citrus2022: loaderCitrus2022 });
var LoadingAnimation = citrusStyled.div('loadingAnimation', {
    legacy: loadingAnimation,
    citrus2022: loadingAnimationCitrus2022,
});
var LoaderDot = citrusStyled.div('loaderDot', { legacy: loaderDot, citrus2022: loaderDotCitrus2022 });
export var LegacySelectPlaceholder = staticSelectPlaceholder;
export var CitronSelectPlaceholder = staticSelectPlaceholderCitrus2022;
export var InputLoader = function () { return (React.createElement(Loader, null,
    React.createElement(LoadingAnimation, null,
        React.createElement(LoaderDot, { className: css(loaderDot1) }),
        React.createElement(LoaderDot, { className: css(loaderDot2) }),
        React.createElement(LoaderDot, null)))); };
export var Styled = {
    Actions: Actions,
    ListRow: ListRow,
    SelectAll: SelectAll,
    SelectStatic: SelectStatic,
    SelectStaticWrapper: SelectStaticWrapper,
    LegacySelectPlaceholder: LegacySelectPlaceholder,
    CitronSelectPlaceholder: CitronSelectPlaceholder,
};
